<template>
  <div>
    <a-form
      id="my_form_styl"
      class="previewModal"
      :label-col="{
        span: 12,
      }"
      :wrapper-col="{
        span: 12,
      }"
      :form="form"
    >
      <template>
        <div style="margin: 25px">
          <span>
            <div>
              <canvas id="the_canvas_detail" />
              <div style="display: flex; justify-content: space-between">
                <a-button
                  :disabled="currentPage - 1 < 1 ? true : false"
                  @click="
                    () => {
                      currentPage--;
                      getpdf();
                    }
                  "
                >
                  <a-icon type="left" />
                  {{ $t("Prev") }}
                </a-button>
                <span>{{ currentPage }} / {{ countPages }}</span>
                <a-button
                  :disabled="currentPage + 1 > countPages ? true : false"
                  @click="
                    () => {
                      currentPage++;
                      getpdf();
                    }
                  "
                >
                  {{ $t("Next") }}
                  <a-icon type="right" />
                </a-button>
              </div>
            </div>
          </span>
        </div>
      </template>

      <a-form-item
        :label="$t('File name')"
        style="margin-top: 10px; border-top: 1px solid #d3d3d3"
      >
        <a-tooltip>
          <template slot="title">
            <span>{{ document.NAME }}</span>
          </template>
          <span>{{ document.NAME }}</span>
        </a-tooltip>
      </a-form-item>

      <a-form-item :label="$t('Status')">
        <a-tag style="font-weight: bold" :color="statusTag.color">{{
          $t(document.status)
        }}</a-tag>
      </a-form-item>

      <a-form-item :label="$t('Main Company')">{{
        MY_COMPANY_LIST[document.my_company]["TITLE"]
      }}</a-form-item>

      <a-form-item :label="$t('Contractor')">{{
        COMPANY_LIST[document.kontragent]["TITLE"]
      }}</a-form-item>

      <a-form-item :label="$t('Bank account')">{{
        document.bankAccount
      }}</a-form-item>
      <a-form-item :label="$t('Invoice number')">{{
        document.num_doc
      }}</a-form-item>
      <a-form-item :label="$t('Type')">{{
        invoiceTypeSelect[document.invoiceType]
      }}</a-form-item>
      <a-form-item
        v-if="document.invoiceCorrection"
        :label="$t('Correction')"
        >{{ document.invoiceCorrection }}</a-form-item
      >
      <a-form-item :label="$t('Payment')">
        <a-col :span="12">{{ document.payment.type }}</a-col>
        <a-col :span="12">{{ document.payment.date }}</a-col>
      </a-form-item>

      <a-form-item :label="$t('Currency')">
        <a-col :span="12">{{ document.currency.code }}</a-col>
        <a-col :span="12">{{ document.currency.val }}</a-col>
      </a-form-item>

      <a-form-item :label="$t('Keywords')">
        <span style="white-space: normal">
          <a-tag v-for="(item, index) in document.key_words" :key="index">{{
            item
          }}</a-tag>
        </span>
      </a-form-item>

      <a-form-item :label="$t('Tag')">
        <a-tag v-for="(item, index) in document.Teczka" :key="index">{{
          item
        }}</a-tag>
      </a-form-item>

      <a-form-item :label="$t('Owner')">
        <span>{{
          MY_COMPANY_LIST[document.my_company]["ASSIGNED_BY_NAME"]
        }}</span>
      </a-form-item>

      <a-form-item
        :label="$t('Date of receiving')"
        style="margin-top: 50px; border-top: 1px solid #d3d3d3"
        >{{ document.date_send }}</a-form-item
      >

      <a-form-item :label="$t('Date of issue')">{{
        document.date_recept
      }}</a-form-item>

      <a-form-item :label="$t('Sale date')">{{
        document.saleDate
      }}</a-form-item>

      <a-form-item :label="$t('Date of payment')">{{
        document.paymentDate
      }}</a-form-item>

      <a-form-item :label="$t('Planned date')">{{
        document.plannedDate
      }}</a-form-item>
      <a-form-item :label="$t('Reminder')">{{
        document.reminderDate
      }}</a-form-item>

      <a-form-item
        :label="$t('Currency')"
        style="margin-top: 50px; border-top: 1px solid #d3d3d3"
        >{{ document.currencyCode }}</a-form-item
      >
      <a-form-item :label="$t('Date of booking')">{{
        document.date_booking
      }}</a-form-item>

      <span style="background-color: #e6f7ff" v-if="document.Quota">
        <a-form-item
          :label="$t('Kwota Netto')"
          style="
            margin-top: 50px;
            border-top: 1px solid #d3d3d3;
            background-color: #e6f7ff;
          "
        >
          <a-statistic :precision="2" :value="document.Quota.Netto" />
        </a-form-item>
        <a-form-item :label="$t('Kwota Vat')" style="background-color: #e6f7ff">
          <a-statistic :precision="2" :value="document.Quota.Vat" />
        </a-form-item>
        <a-form-item
          :label="$t('Kwota Brutto')"
          style="background-color: #e6f7ff"
        >
          <a-statistic :precision="2" :value="document.Quota.Bruto" />
        </a-form-item>
      </span>
    </a-form>
    <a-table
      v-if="document.invoiceTable.length"
      :columns="DescInvoiceColumns"
      :data-source="document.invoiceTable"
      :pagination="{ hideOnSinglePage: true }"
      bordered
    ></a-table>

    <template v-if="document.status != 'ZAREJESTROWANE' && ready">
      <a-table
        v-for="(item, index) in document.invoiceTable"
        :key="index"
        :columns="columnsPosition"
        :data-source="item.sum_distribution"
        :pagination="{ hideOnSinglePage: true }"
        bordered
        size="small"
      >
        <template
          slot="operation"
          slot-scope="text, record"
          v-if="document.status != 'OPISANE FVK'"
        >
          <span style="margin-right: 15px">
            <span v-if="record.accept.status">
              <a-icon
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
              />&nbsp;Tak
            </span>
            <span v-else>
              <a-icon
                type="close-circle"
                theme="twoTone"
                two-tone-color="#eb2f96"
              />&nbsp;Nie
            </span>
          </span>
          <a-tooltip placement="bottomRight">
            <template slot="title" v-if="document.status == 'ROZKSIEKOWANE'">
              <a-tag
                color="#2C7FE4"
                v-for="item in record.accept.accept_users"
                :key="item"
                >{{
                  USER_LIST[item]["NAME"] + " " + USER_LIST[item]["LAST_NAME"]
                }}</a-tag
              >
            </template>
            <template slot="title" v-else>
              <a-tag color="#2C7FE4">{{
                USER_LIST[record.accept.user]["NAME"] +
                " " +
                USER_LIST[record.accept.user]["LAST_NAME"]
              }}</a-tag>
            </template>
            <a-icon type="user" />
          </a-tooltip>
        </template>

        <template slot="title">
          <a-row
            type="flex"
            justify="space-around"
            align="middle"
            style="font-weight: 700"
          >
            <span
              >{{ $t("Position") + " " + ++index }} : {{ item.namefield }} ({{
                item.sum
              }})</span
            >
          </a-row>
          <div></div>
        </template>
      </a-table>
    </template>
  </div>
</template>
<script>

//import printJS from "print-js";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");

export default {
  props: [
    "document",
    "statusTag",
    "MY_COMPANY_LIST",
    "COMPANY_LIST",
    "USER_LIST",
    "DEAL_LIST",
    "defaultResponsible",
  ],
  data() {
    return {
      docPdf: true,
      ready: false,
       currentPage: 1,
      DescInvoiceColumns: [
        {
          title: "Nazwa towaru/uslugi",
          dataIndex: "namefield",
          width: "52%",
        },
        {
          title: "Wartosc netto",
          dataIndex: "koszty",
          width: "12%",
        },
        {
          title: "Stawka VAT",
          dataIndex: "vat",
          width: "12%",
        },
        {
          title: "Kwota VAT",
          width: "12%",
          dataIndex: "vat2",
        },
        {
          title: "Wartosc z VAT",
          width: "12%",
          dataIndex: "sum",
        },
      ],
      columnsPosition: [
        {
          title: "Centry kosztów",
          dataIndex: "mpk",
          width: "20%",
        },
        {
          title: "Typy kosztów",
          dataIndex: "type",
          width: "20%",
        },
        {
          title: "Projekty",
          dataIndex: "deal",
          width: "20%",
          customRender: (text) =>
            text ? this.DEAL_LIST.find((x) => x.ID == text)["TITLE"] : "",
        },
        {
          title: "Firma",
          dataIndex: "firma",
          width: "20%",
          customRender: (text) =>
            text ? this.COMPANY_LIST[text]["TITLE"] : "",
        },
        {
          title: "Kwota",
          dataIndex: "sum",
          width: "10%",
        },
        {
          title: "Zaakceptowane",
          dataIndex: "operation",
          width: "10%",
          scopedSlots: { customRender: "operation" },
        },
      ],
      invoiceTypeSelect: {
        "Faktura Kosztowa": "Faktura Kosztowa",
        Proforma: "Proforma",
        "VAT Marza": "Faktura do Proformy",
        Korygujaca: "Korygująca",
        "Faktura zaliczkowa": "Faktura zaliczkowa",
        "Faktura koncowa": "Faktura końcowa",
      },
    };
  },
  methods: {
    getpdf() {
     // this.prew_doc_spinner = true;
      var url = this.document.url;
      //var pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(url);
      loadingTask.promise.then(
        (pdf) => {
          try {
            this.countPages = pdf.numPages;

            if (1 <= this.currentPage && this.countPages >= this.currentPage)
              pdf.getPage(this.currentPage).then((page) => {
                var scale = 2.0;
                var viewport = page.getViewport({ scale: scale });
                var canvas = document.getElementById("the_canvas_detail");
                //var canvas = $('#the_canvas_detail');
                var context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then(() => {
                  //canvas.style.display = "unset";
                });
              });
          } catch {
//
          }
        },
        (reason) => {
          console.error(reason);
        }
      );
    },
  },
  mounted() {
    this.getpdf();
    for (let i in this.document.invoiceTable) {
      for (let j in this.document.invoiceTable[i].sum_distribution) {
        let item = this.document.invoiceTable[i].sum_distribution[j];
        if (this.document.right[this.document.my_company]["ACCESS"]) {
          let filter = this.document.right[this.document.my_company]["ACCESS"]
            .filter((x) => x.MPK.includes(item.mpk))
            .flatMap((x) => x.verifications);
          if (this.document.right[this.document.my_company]["HUBLIDER"])
            filter.push(
              this.document.right[this.document.my_company]["HUBLIDER"]
            );
          if (this.defaultResponsible.verification)
            filter.push(this.defaultResponsible.verification);

          if (this.defaultResponsible.processing)
            filter.push(this.defaultResponsible.processing);

          item["accept"]["accept_users"] = [...new Set(filter)];
        } else {
          item["accept"]["accept_users"] = [];
        }

        item["accept"]["status"] = item["accept"]["status"] == "true";
        item["accept"]["user"] = "";
      }
    }
    this.ready = true;
    // this.form = this.$form.createForm(this, { name: "form_5" });

    BX24.fitWindow();
  },
};
</script>

<style scoped>
</style>
